import { render, staticRenderFns } from "./PopupDelete.vue?vue&type=template&id=0a845439&scoped=true&"
import script from "./PopupDelete.vue?vue&type=script&lang=js&"
export * from "./PopupDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a845439",
  null
  
)

export default component.exports